export default "__VITE_ASSET__Bamuj7HZ__"